export default __webpack_public_path__ + "static/media/test-icon.5ee1b746.svg";